import Keycloak from 'keycloak-js';

const authBase = (
  process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:4702/auth'
).replace(/\/$/, '');

export const keycloak = new Keycloak({
  // keycloak-js appends /.well-known/openid-configuration — pass the auth base only.
  oidcProvider: authBase,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'surveillance',
});

let keycloakInitComplete = false;

export function isKeycloakInitialized(): boolean {
  return keycloakInitComplete;
}

export function markKeycloakInitialized(): void {
  keycloakInitComplete = true;
}

/** True only after keycloak.init() succeeded — not for gateway ?token= login. */
export function hasActiveKeycloakSession(): boolean {
  return Boolean(keycloak.authenticated && keycloak.token);
}
